import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useStoreState } from "easy-peasy";

const ProgressBar = ({ now, mobileResponsiveUtil, content }) => {
  const CONTAINER_ID = "interactiveExpProgress";
  const [barWidth, setBarWidth] = useState(now);
  const { player: videoPlayer, currentPlayingTime } = useStoreState(
    (state) => state.stage
  );
  const { startTime } = useStoreState((state) => state.demo);

  useEffect(() => {
    if (videoPlayer) {
      setBarWidth(
        ((currentPlayingTime - startTime) /
          (videoPlayer.duration() - startTime)) *
          100
      );
    }
    return () => {};
  }, [currentPlayingTime, videoPlayer, setBarWidth, startTime]);

  return (
    <div id={CONTAINER_ID}>
      <div className="demo__navigation-progress-bar">
        <div className="progress-bar__progress js-progress-bar__progress">
          <div className="progress-bar__progress-pointer" />
        </div>
      </div>
      <style jsx="true">
        {`
          #${CONTAINER_ID} .demo__navigation-progress-bar {
            height: ${Math.ceil(
              mobileResponsiveUtil.getHeightValue(4)
            )}px !important;
            margin-top: ${mobileResponsiveUtil.getHeightValue(30)}px !important;
            margin-bottom: ${mobileResponsiveUtil.getHeightValue(
              17
            )}px !important;

            position: relative !important;

            width: 98% !important;
            margin-right: auto !important;
            margin-left: auto !important;

            border-radius: 500px !important;
            background-color: #ffffff !important;
          }

          #${CONTAINER_ID} .progress-bar__progress {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;

            width: ${barWidth}% !important;
            height: ${Math.ceil(
              mobileResponsiveUtil.getHeightValue(4)
            )}px !important;
            transform-origin: 0 0 !important;

            background-color: ${(content && content.color) ||
            "#60a212"} !important;
            // transition: all 1s linear !important;
          }

          #${CONTAINER_ID} .progress-bar__progress-pointer {
            width: ${mobileResponsiveUtil.getWidthValue(12)}px !important;
            height: ${mobileResponsiveUtil.getHeightValue(12)}px !important;
            right: -${mobileResponsiveUtil.getWidthValue(6)}px !important;

            position: absolute !important;
            top: 50% !important;

            transform: translateY(-50%) !important;

            border-radius: 50% !important;
            background-color: ${(content && content.color) ||
            "#60a212"} !important;
          }
        `}
      </style>
    </div>
  );
};

ProgressBar.propTypes = {
  now: PropTypes.number,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
  content: PropTypes.object,
};

ProgressBar.defaultProps = {
  content: {
    color: "#60a212",
  },
  now: 0,
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};

export default ProgressBar;
